import "@/App.css";
import { ReactLenis } from "lenis/react";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import MarqueeStrip from "@/components/MarqueeStrip";
import Services from "@/components/Services";
import Manifesto from "@/components/Manifesto";
import Testimonials from "@/components/Testimonials";
import FAQ from "@/components/FAQ";
import Booking from "@/components/Booking";
import Contact from "@/components/Contact";
import WhatsAppFloat from "@/components/WhatsAppFloat";

export default function App() {
  return (
    <ReactLenis root options={{ lerp: 0.09, smoothWheel: true }}>
      <div className="bg-ink text-bone font-sans min-h-screen">
        <div className="noise-overlay" />
        <Navbar />
        <main>
          <Hero />
          <MarqueeStrip />
          <Services />
          <Manifesto />
          <Testimonials />
          <FAQ />
          <Booking />
          <Contact />
        </main>
        <WhatsAppFloat />
      </div>
    </ReactLenis>
  );
}
